module.exports = __webpack_public_path__ + "static/media/Cairo-Black.4da6b79a.woff";